// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2b25f32b","416":"c1320c71","534":"903f5804","538":"d8b4b480","566":"32c38d72","614":"c4022a98","676":"69af0fc4"}[chunkId] + ".chunk.js";
};